module.exports = __webpack_public_path__ + "img/light-mapicon.640fdee7.png";